import { TransactionIdAndType, InteracTransactionResponse, TransactionType } from 'vopay';
import { useEffect, FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '../../hooks/useApi/useFetchInteracMoneyRequestTransaction';
import useAccountBearer from '@/hooks/useApi/useAccountBearer';

const InteracMoneyRequestTransactionContainer: FC<TransactionIdAndType> = ({
  TransactionID,
  Type,
}: TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const token = useAccountBearer(accountId);

  const [InteracMoneyRequest, getInteracMoneyRequestTransaction] = useFetchInteracMoneyRequestTransaction({
    bearer: token,
  });

  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<InteracTransactionResponse>();

  useEffect(() => {
    if (!token) return;

    if (Type === TransactionType.INTERACT_MONEY_REQUEST) {
      getInteracMoneyRequestTransaction(TransactionID);
    }
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (InteracMoneyRequest) {
      setTransaction(InteracMoneyRequest);
    }
  }, [InteracMoneyRequest]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && <InteracMoneyRequestTransactionInfo transaction={transaction} />}
    </div>
  );
};

export default InteracMoneyRequestTransactionContainer;
